import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Error from 'components/Error';
import { OrbsHeader } from 'components/Orbs';
import { TopIssues } from 'components/TopIssues';
import { MaximizeImpact } from 'components/MaximizeImpact';
import { SetSection } from 'components/SetSection';
import { trackEvent } from 'helpers/mixpanelEvents';
import { getPathWithRef, getUrlParams, scrollToTop } from 'helpers/utils';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { useAuth } from 'hooks/auth';
import { getSetsData, getSetsState } from 'selectors/sets';
import { getSets } from 'store/sets/actions';
import { getUserProfile } from 'store/user/actions';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';
import { getSectionImageUrl } from 'helpers/imageUrls';

export const SetScreen = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { urlPartner } = getUrlParams();
  const { setsState, setsData } = useAppSelector(state => ({
    setsState: getSetsState(state),
    setsData: getSetsData(state),
  }));

  useAuth(() => {
    dispatch(getUserProfile());
  });

  useEffect(() => {
    if (!urlPartner) navigate(getPathWithRef('/'));
    else {
      dispatch(getSets(urlPartner));
      trackEvent('Set Page Viewed', { set_query_str: urlPartner });
      scrollToTop();
    }
  }, []);

  return (
    <HeaderAndFooterLayout
      footerWhiteLabeled={!!setsData?.set_misc?.whitelabeled}
      headerVisible={!setsData?.set_misc?.whitelabeled}
      isLoading={!setsState.error && !setsData}
      hasIssues={true}
    >
      {setsState.error || (setsData && !setsData.pages.length) ? (
        <Error
          data={{ component: 'Set screen' }}
          errorMsg="Set page data not found."
          shouldAlert={false}
        >
          <span className="h3-dtm">Set page data not found. Please check url and try again.</span>
        </Error>
      ) : (
        <>
          <OrbsHeader />
          <div className="sets-content">
            <TopIssues pages={setsData?.pages} />
          </div>
          {setsData?.set_misc?.sections?.map((section, index) => (
            <SetSection
              key={section.id ?? index}
              section={section}
              tertiaryColor={setsData?.set_misc?.tertiary_color || ''}
              imageUrl={
                section.has_image && section.id
                  ? getSectionImageUrl(setsData, section.id, urlPartner)
                  : undefined
              }
            />
          ))}
          <MaximizeImpact />
        </>
      )}
    </HeaderAndFooterLayout>
  );
};
